import { checkBoxChanged } from '@job-facets/redux/jobsFilterSlice';
import { isDesktopDevice } from '@core/components/utility';

function whenCheckBoxChanged(e, dispatch, slug) {
	const updatedValue = e.target.value;
	dispatch(
		checkBoxChanged({
			value: updatedValue,
			slug,
		}),
	);
}

/**
 * Not all facet field required search options.
 */
function optionSearchLogic(slug) {
	// disable search on following fields
	const disableSearch = ['is_remote_position'];

	if (disableSearch.includes(slug)) {
		return false;
	}
	return true;
}

function openAccordionToggle(facetSlug, data) {
	let openAccordionToggle = false;

	if (!isDesktopDevice()) {
		return openAccordionToggle;
	}

	if (isDesktopDevice()) {
		openAccordionToggle = true;
	}

	const facets = [
		'job_listing_company_size',
		'job_listing_industry',
		'is_remote_position',
	];

	if (facets.includes(facetSlug)) {
		openAccordionToggle = false;
	}

	/**
	 * If there are filled facet from the url query params, then the facet should be opened by default
	 */
	const currentFacet = data[facetSlug];

	if (Array.isArray(currentFacet) && currentFacet.length > 0) {
		openAccordionToggle = true;
	}

	return openAccordionToggle;
}

export default whenCheckBoxChanged;
export { optionSearchLogic, openAccordionToggle };
